import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ef19038"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-block" }
const _hoisted_2 = { class: "employee" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "身份证号：", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("当前")
const _hoisted_6 = { class: "f-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "被派遣单位：", -1))
const _hoisted_8 = { class: "f-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "工种：", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("更换至")
const _hoisted_11 = { class: "f-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "生效时间：", -1))
const _hoisted_13 = { class: "f-row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "被派遣单位：", -1))
const _hoisted_15 = { class: "f-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "工种：", -1))
const _hoisted_17 = { class: "foot" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createBlock(_component_alert_box, {
    dataTitle: "员工换厂",
    width: "650px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.row.name), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_4,
              _createTextVNode(_toDisplayString(_ctx.row.idcard), 1)
            ])
          ]),
          _createVNode(_component_el_tag, { class: "mini-title" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, _toDisplayString(_ctx.row.company_name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, _toDisplayString(_ctx.row.occupation_name) + "（" + _toDisplayString(_ctx.row.occupation_level) + "类）", 1)
          ]),
          _createVNode(_component_el_tag, {
            type: "success",
            class: "mini-title"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", null, _toDisplayString(_ctx.tommorow), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_autocomplete, {
              "fetch-suggestions": _ctx.autoCompany,
              class: "form-value",
              modelValue: _ctx.company_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company_name) = $event)),
              placeholder: "请选择被派遣单位",
              onSelect: _ctx.selectCompany
            }, null, 8, ["fetch-suggestions", "modelValue", "onSelect"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_select, {
              class: "form-value",
              modelValue: _ctx.occupation_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.occupation_name) = $event)),
              placeholder: "请选择工种",
              onChange: _ctx.selectOccupation
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.occupationAutoData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.occupation_id,
                    label: item.name + '（' + item.level + '类）',
                    value: item.occupation_id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn-white alone",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, " 取 消 "),
            _createElementVNode("button", {
              class: "btn alone",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
            }, "确 定")
          ])
        ])
      ])
    ]),
    _: 1
  }))
}